import React from 'react'
import ConfigPageLayout from '../components/ConfigPageLayout'
import PaymentConfigSection from '../components/PaymentConfigSection'

export default function PaymentConfigPage() {
  return (
    <ConfigPageLayout title="PAIEMENTS" description="Configuration des paiements et abonnements Stripe">
      <div className="rounded-3xl border border-emerald-100/80 bg-white/90 p-8 shadow-xl shadow-emerald-500/10 dark:border-emerald-900/50 dark:bg-zinc-950/90">
        <PaymentConfigSection />
      </div>
    </ConfigPageLayout>
  )
}
